var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWiegen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    x1: 12.827,
    y1: 2.513,
    x2: 18.703,
    y2: 2.513
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    x1: 20,
    y1: 18.364,
    x2: 20,
    y2: 3.985
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    x1: 12.827,
    y1: 18.39,
    x2: 27.173,
    y2: 18.39
  }), /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    cx: 20,
    cy: 2.513,
    r: 1.445
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.61,
    d: "M13.407,4.821"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.762,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 15,
    points: " 13.328,4.558 8.944,12.578 17.712,12.578  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M8.936,12.578c0,1.415,1.963,2.579,4.384,2.579c2.422,0,4.385-1.164,4.385-2.579"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.762,
    d: "M8.936,12.578 c0,1.415,1.963,2.579,4.384,2.579c2.422,0,4.385-1.164,4.385-2.579"
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    x1: 21.297,
    y1: 2.513,
    x2: 27.173,
    y2: 2.513
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.762,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 15,
    points: " 26.68,4.558 22.295,12.578 31.064,12.578  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M22.288,12.578c0,1.415,1.963,2.579,4.384,2.579s4.384-1.164,4.384-2.579"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.762,
    d: "M22.288,12.578 c0,1.415,1.963,2.579,4.384,2.579s4.384-1.164,4.384-2.579"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiegen);
export default __webpack_public_path__ + "static/media/wiegen.e3ec17c2bb169daf95c2d0015b9fa890.svg";
export { ForwardRef as ReactComponent };